import React from 'react'
import TabsTemplate from '../../../../templates/components/TabsTemplate'
import UserSettingsTable from './user/user-settings-table/UserSettingsTable'
import UserRolesTable from './user-roles/user-roles-table/UserRolesTable'
import LocationUsers from './location-users/LocationUsers'
const SecuritySettings = (props) => {
    const { isUserLogin } = props;
    return (
        <TabsTemplate>
            <div title='Manage Users'>
                <UserSettingsTable />
            </div>
            <div title='Manage Roles' hide={isUserLogin}>
                <UserRolesTable/>
            </div>
            <div title='Location Users' hide={isUserLogin}>
                <LocationUsers/>
            </div>
        </TabsTemplate>
    )
}

export default SecuritySettings